import { PriceExtraction } from '../../../../../@types/IPA/PriceExtraction';
import { ExtractionFiltersValuesState } from '../../../../../reducers/ipa/extraction/filters/values';
import { ExtractionPaginationState } from '../../../../../reducers/ipa/extraction/table/pagination';
import { getValidData } from '../../../RevisaoPrecos/utils';

type RowData = PriceExtraction['rowData'];

export const GET_extractionDatapointsMapper = ({ value, pagination }: { value: ExtractionFiltersValuesState; pagination?: ExtractionPaginationState }) => {
  return getValidData({
    ...value,
    page: (pagination?.activePage ?? 1) - 1,
    size: pagination?.displayLength,
    appied: true,
  });
};

export const normalizeWholesaleValue = (value: RowData['wholesale'] | undefined) => {
  if (value === null || value === undefined || value === 0) {
    return null;
  }

  return value;
};
